export const convertStringToCamelCaseId = (text) => {
    const words = text
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase: "femalePov" → "female Pov"
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2") // Split acronyms: "LGBTQPlus" → "LGBTQ Plus"
        .match(/[a-zA-Z]+|\d+(?:\.\d+)?(?:[a-z]+|[A-Z](?![a-z]))?/g) ?? []; // Extract words and numeric tokens
    return words
        .map((word, i) => i === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join("");
};
